import gql from 'graphql-tag';
import { COMMENT_TYPE } from './CommentType.gql';

export const DELETE_COMMENT = gql`
  ${COMMENT_TYPE}
  mutation deleteComment($commentId: ID!) {
    deleteComment(commentId: $commentId) {
      comment {
        ...CommentType
      }
    }
  }
`;
